import type { IconSvgObject } from './types';

const ALargeSmallIcon: IconSvgObject = [
  ["path", { d: "M11 17L7.1857 7.46424C7.07354 7.18385 6.80198 7 6.5 7C6.19802 7 5.92646 7.18385 5.8143 7.46424L2 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 17L19.1756 9.46816C19.07 9.18656 18.8008 9 18.5 9C18.1992 9 17.93 9.18656 17.8244 9.46816L15 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.5 14H20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M4 13H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ALargeSmallIcon;
